import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e9a990e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "evolution-chart-controller"
};
const _hoisted_2 = {
  class: "metric-selector"
};
const _hoisted_3 = {
  width: "8",
  height: "9",
  viewBox: "0 0 8 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_4 = ["fill"];
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "selected"
};
const _hoisted_7 = {
  class: "overflow-wrapper"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = ["id"];
const _hoisted_10 = ["id"];
const _hoisted_11 = {
  key: 0,
  class: "compare"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Compare with ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_stroked_view_icon = _resolveComponent("stroked-view-icon");
  const _component_stroked_hide_icon = _resolveComponent("stroked-hide-icon");
  const _component_search_element = _resolveComponent("search-element");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock("svg", _hoisted_3, [_createElementVNode("circle", {
    cx: "4",
    cy: "4.5",
    r: "4",
    fill: $props.color
  }, null, 8, _hoisted_4)])), _createElementVNode("div", _hoisted_5, _toDisplayString($props.title), 1)]), _createVNode(_component_app_dropdown, null, {
    "button-content": _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString($options.metric?.label), 1), $options.metric ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "eye-icon",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('toggle-visibility'), ["stop"]))
    }, [$options.metric.visible ? (_openBlock(), _createBlock(_component_stroked_view_icon, {
      key: 0
    })) : (_openBlock(), _createBlock(_component_stroked_hide_icon, {
      key: 1
    }))])) : _createCommentVNode("", true)]),
    body: _withCtx(() => [_createVNode(_component_search_element, {
      placeholder: "Search",
      onFocus: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
      onSearch: $options.handleSearch
    }, null, 8, ["onSearch"]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredOptions, ([key, valueArray]) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: key
      }, [_createElementVNode("div", _hoisted_8, _toDisplayString(key), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueArray, value => {
        return _openBlock(), _createBlock(_component_b_dropdown_item, {
          key: value.label,
          onClick: $event => $options.metric = value,
          target: value.key,
          active: $options.metric?.key == value?.key
        }, {
          default: _withCtx(() => [$options.getKpiDescription(value?.key) ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
            key: 0,
            placement: "right"
          }, {
            title: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($options.getKpiDescription(value?.key)?.title), 1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getKpiDescription(value?.key)?.detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              id: value.key
            }, _toDisplayString(value.fullLabel ?? value.label), 9, _hoisted_9)]),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: value.key
          }, _toDisplayString(value.fullLabel ?? value.label), 9, _hoisted_10))]),
          _: 2
        }, 1032, ["onClick", "target", "active"]);
      }), 128))], 64);
    }), 128))])]),
    _: 1
  }), $props.showEvolution ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.compareOptions, ({
    text,
    value
  }) => {
    return _openBlock(), _createBlock(_component_b_form_checkbox, {
      key: value,
      modelValue: $options.compareSelected,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.compareSelected = $event),
      value: value,
      name: value,
      id: value,
      "unchecked-value": null
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(text), 1)]),
      _: 2
    }, 1032, ["modelValue", "value", "name", "id"]);
  }), 128))])) : _createCommentVNode("", true)]);
}